module.exports = __webpack_public_path__ + "img/banner-TV-1--old__sm.282d2a7c.jpg";